<template>
  <div
    id="kt_modal_modulos_editar"
    ref="kt_modal_modulos_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Modulo
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Modulo
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row" v-if="!loading">
            <div
              class="col-sm-9 col-md-9 col-lg-10 col-xl-10 col-xxl-10 fv-row mb-2"
            >
              <label class="required form-label">Nome do módulo</label>
              <input
                :id="`txtNome`"
                type="text"
                class="form-control mb-2"
                placeholder="Nome do módulo"
                maxlength="255"
                v-model="this.modulo.nome"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["nome"] }}
              </div>
            </div>
            <div
              class="col-sm-3 col-md-3 col-lg-2 col-xl-2 col-xxl-2 fv-row mb-2 align-items-center"
              style="align-self: center"
            >
              <div
                class="form-check pt-5 form-switch form-check-custom form-check-solid"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchChecked"
                  :checked="this.modulo.ativo === '1'"
                  @change="
                    this.modulo.ativo = this.modulo.ativo === '1' ? '0' : '1'
                  "
                />
                <label
                  class="form-check-label fw-bold fs-6"
                  for="flexSwitchChecked"
                  >Ativo</label
                >
              </div>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["ativo"] }}
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div
              class="mb-7"
              v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
            >
              <span class="indicator-progress">
                Aguarde, carregando...
                <span
                  class="spinner-border spinner-border-sm align-middle ms-2"
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import { hideModal } from "@/core/helpers/dom";
const toast = useToast();

const moduloInicializado = {
  id: 0,
  nome: "",
  ativo: "1",
};

export default {
  emits: ["exibirEditarModuloModal", "confirmarEditarModuloModal"],
  components: {},
  props: {
    id: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if (this.id <= 0) {
        try {
          var ret = await this.$store.dispatch(
            "relatoriosModulos/postRelatoriosModulos",
            this.modulo
          );
          if (ret.Success === true) {
            toast.success("Módulo cadastrado com sucesso!", {
              timeout: 3000,
            });
            this.$emit("confirmarEditarModuloModal", false);
            hideModal(this.$refs.kt_modal_modulos_editar);
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "relatoriosModulos/putRelatoriosModulos",
            this.modulo
          );
          if (retPut.Success === true) {
            toast.success("Módulo alterado com sucesso!", { timeout: 3000 });
            this.$emit("confirmarEditarModuloModal", false);
            hideModal(this.$refs.kt_modal_modulos_editar);
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loading = false;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_modulos_editar);
      this.$emit("exibirEditarModuloModal", false);
    },
  },
  async mounted() {
    this.errosValidacao = [];

    if (this.id <= 0) {
      this.modulo = JSON.parse(JSON.stringify(moduloInicializado));
    } else {
      try {
        this.loading = true;
        let ret = await this.$store.dispatch(
          "relatoriosModulos/getRelatoriosModulos",
          this.id
        );

        if (ret.Success === true) {
          this.modulo = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    }

    this.$utils.requestFocus(`txtNome`);
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      modulo: {},
    };
  },
};
</script>

<style></style>
